<script lang="ts">
	import { onMount } from 'svelte'
	import type { HamburgerMenuItem } from '@repo/commons/models'

	interface Props {
		items?: HamburgerMenuItem[]
		onItemSelected?: ((item: HamburgerMenuItem) => void) | null
	}

	let { items = [], onItemSelected = null }: Props = $props()

	let selectedItemId: string | null = $state(null)

	function selectItem(item: HamburgerMenuItem) {
		selectedItemId = item.id
		onItemSelected?.(item)
	}

	onMount(() => {
		if (items.length > 0) {
			// ofc do not dispatch the event here
			selectedItemId = items[0].id
		}
	})
</script>

<div class="hamburger-menu">
	{#each items as item}
		<div
			class="item {item.id === selectedItemId ? 'selected' : ''}"
			onclick={() => selectItem(item)}
		>
			{item.readableName}
		</div>
	{/each}
</div>

<style>
	.hamburger-menu {
		@apply w-48 bg-se-grey-1 p-2;
	}

	.item {
		@apply p-2 cursor-pointer text-white;
	}

	.item.selected {
		@apply bg-gray-300 text-black;
	}
</style>
